import { Field } from '../fields';

export interface WithdrawalMerchant {
  id: number;
  alias: string;
  name: string;
  fields: Field[];
}
